import _ from "lodash";
import * as Actions from "../actions/productReview";

export const initialState = {
  productReviewLastUpdatedDate: {},
  productReviewLastUpdatedDateFetching: false,
  productReviewLastUpdatedDateError: {},
  productReviews: [],
  productReviewsNext: "",
  fetchingProductReviews: false,
  fetchingProductReviewsNext: false,
  currentFilterStatus: 1,
  fetchingProductReviewsError: {},
  selectedProduct: {},
  fetchingSelectedProductDetails: false,
  selectedProductError: {},
  updatingCurrentProductDetails: false,
  updatingProductStatus: false,
  productReviewSearch: "",
  logs: [],
  next: null,
  previous: null,
  error: null,
  fetchingIngredientLogs: false,
  ingredientLogFilter: "",
  loadingBarcodeMatches: false,
  barcodeMatchesError: null,
  barcodeMatches: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Actions.GET_PRODUCT_REVIEW_LAST_UPDATED_DATE:
      return {
        ...state,
        productReviewLastUpdatedDateFetching: true,
      };
    case Actions.SET_PRODUCT_REVIEW_LAST_UPDATED_DATE:
      return {
        ...state,
        productReviewLastUpdatedDate: action.response,
        productReviewLastUpdatedDateFetching: false,
      };
    case Actions.SET_CURRENT_FILTER_STATUS:
      return {
        ...state,
        currentFilterStatus: _.get(action, "payload", 1),
      };
    case Actions.GET_PRODUCT_REVIEWS:
      return {
        ...state,
        fetchingProductReviews: true,
        fetchingProductReviewsNext: false,
        productReviews: [],
      };
    case Actions.GET_PRODUCT_REVIEWS_SUCCESS:
      return {
        ...state,
        productReviews: _.get(action, "result.results", []),
        productReviewsNext: _.get(action, "result.next", ""),
        fetchingProductReviewsNext: false,
        fetchingProductReviews: false,
      };
    case Actions.GET_PRODUCT_REVIEWS_ERROR:
      return {
        ...state,
        productReviews: [],
        fetchingProductReviewsNext: false,
        fetchingProductReviews: false,
        fetchingProductReviewsError: _.get(action, "error", {}),
      };
    case Actions.GET_PRODUCT_REVIEWS_NEXT:
      return {
        ...state,
        fetchingProductReviewsNext: true,
      };
    case Actions.GET_PRODUCT_NEXT_REVIEWS_SUCCESS:
      return {
        ...state,
        productReviews: [...state.productReviews, ..._.get(action, "result.results", [])],
        productReviewsNext: _.get(action, "result.next", ""),
        fetchingProductReviewsNext: false,
      };
    case Actions.GET_PRODUCT_NEXT_REVIEWS_ERROR:
      return {
        ...state,
        productReviews: [],
        fetchingProductReviewsNext: false,
        fetchingProductReviews: false,
        fetchingProductReviewsError: _.get(action, "error", {}),
      };
    case Actions.UPDATE_PRODUCT_REVIEW_STATUS:
      return {
        ...state,
        productReviews: _.reject(state.productReviews, ["id", action.payload.id]),
      };
    case Actions.GET_SELECTED_PRODUCT_DETAILS:
      return {
        ...state,
        fetchingSelectedProductDetails: true,
      };
    case Actions.GET_SELECTED_PRODUCT_DETAILS_SUCCESS:
      return {
        ...state,
        fetchingSelectedProductDetails: false,
        selectedProduct: _.get(action, "response", {}),
      };
    case Actions.GET_SELECTED_PRODUCT_DETAILS_ERROR:
      return {
        ...state,
        fetchingSelectedProductDetails: false,
        selectedProductError: _.get(action, "error", {}),
      };
    case Actions.UPDATE_SELECTED_PRODUCT_DETAILS:
      return {
        ...state,
        updatingCurrentProductDetails: true,
      };
    case Actions.UPDATE_SELECTED_PRODUCT_DETAILS_SUCCESS:
      return {
        ...state,
        updatingCurrentProductDetails: false,
        updatingProductStatus: false,
      };
    case Actions.RESET_SELECTED_PRODUCT_DETAILS:
      return {
        ...state,
        selectedProduct: {},
        updatingCurrentProductDetails: false,
        updatingProductStatus: false,
      };
    case Actions.PUBLISH_SELECTED_PRODUCT_DETAILS:
      return {
        ...state,
        updatingProductStatus: true,
      };
    case Actions.PUBLISH_SELECTED_PRODUCT_DETAILS_SUCCESS:
      return {
        ...state,
        updatingProductStatus: false,
      };
    case Actions.PRODUCT_REVIEW_SEARCH:
      return {
        ...state,
        productReviewSearch: action.searchValue,
      };
    case Actions.PRODUCT_REVIEW_SEARCH_CLEAR: {
      return {
        ...state,
        productReviewSearch: "",
      };
    }
    case Actions.UPDATE_SELECTED_PRODUCT_DETAILS_ERROR: {
      return {
        ...state,
        updatingCurrentProductDetails: false,
        updatingProductStatus: false,
      };
    }
    case Actions.PRODUCT_REVIEW_UPLOAD_PRODUCT_PHOTO_SUCCESS: {
      const existingImages = state.selectedProduct.images || [];

      // For DELETE operations, remove the deleted image by id, or the image at the given position
      if (action.operation === "deletingImage") {
        return {
          ...state,
          selectedProduct: {
            ...state.selectedProduct,
            images: existingImages.filter(img => (action.imageId ? img.id !== action.imageId : img.position !== action.position)),
          },
        };
      }

      // For POST/PATCH operations, update or add the image
      const uploadedImage = action.response;
      const existingIndex = existingImages.findIndex(img => img.id === uploadedImage.id);

      let updatedImages;
      if (existingIndex >= 0) {
        updatedImages = [...existingImages];
        updatedImages[existingIndex] = uploadedImage;
      } else {
        updatedImages = [...existingImages, uploadedImage].sort((a, b) => a.position - b.position);
      }

      return {
        ...state,
        selectedProduct: {
          ...state.selectedProduct,
          images: updatedImages,
        },
      };
    }
    case Actions.GET_INGREDIENT_LOGS:
      return {
        ...state,
        fetchingIngredientLogs: true,
        error: null,
      };
    case Actions.GET_INGREDIENT_LOGS_NEXT:
      return {
        ...state,
        fetchingIngredientLogs: true,
        error: null,
      };
    case Actions.SET_INGREDIENT_LOGS:
      return {
        ...state,
        logs: action.payload.logs,
        next: action.payload.next,
        previous: action.payload.previous,
        fetchingIngredientLogs: false,
        ingredientLogFilter: action.payload.filter,
      };
    case Actions.SET_FETCHING_ERROR:
      return {
        ...state,
        fetchingIngredientLogs: false,
        error: action.payload,
      };
    case Actions.GET_BARCODE_MATCHES:
      return {
        ...state,
        loadingBarcodeMatches: true,
        barcodeMatchesError: null,
        barcodeMatches: [],
      };
    case Actions.GET_BARCODE_MATCHES_SUCCESS:
      return {
        ...state,
        barcodeMatches: action.payload?.results || [],
        loadingBarcodeMatches: false,
      };
    case Actions.GET_BARCODE_MATCHES_FAILURE:
      return {
        ...state,
        loadingBarcodeMatches: false,
        barcodeMatchesError: action.payload,
        barcodeMatches: [],
      };
      case Actions.CLEAR_BARCODE_MATCHES: {
        return {
          ...state,
          barcodeMatches: [],
        };
      };
    default:
      return state;
  }
};
